import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  height: 1000px;
  flex-direction: column;
  width: 200px;
`;

export const LogoWrapper = styled.div`
  position: sticky;
  top: 180px;
`;

export const ButtonWrapper = styled.div`
  position: sticky;
  top: 400px;
`;

export const SocialMediaWrapper = styled.div`
  position: sticky;
  top: 560px;
`;
